<template>
  <div>
    <!-- <Header /> -->
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <confirmPopup
      v-if="popupwindow == true"
      :title="titlepass"
      @cancelClick="popupwindow = false"
      @confirmClick="deletecourse(idpass)"
    />
    <div class="flex flex-col lg:flex-row">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex flex-col gap-5 p-5">
          <div
            class="flex flex-col md:flex-row justify-between items-start gap-4"
          >
            <h1 class="text-2xl font-bold text-primary text-start md:text-left">
              My Courses
            </h1>

            <!-- {{ courselist }} -->

            <form
              @submit.prevent="searchUserValue"
              class="flex w-full md:w-auto"
            >
              <input
                type="text"
                name="search"
                id="search"
                v-model="search_title"
                @input="searchUserValue"
                placeholder="Search The Course"
                class="border-2 rounded-l-xl px-4 py-2 w-full md:w-[230px] outline-none"
              />
              <div class="flex justify-end items-center gap-3">
                <button
                  type="submit"
                  :disabled="disable_submit == true"
                  :class="
                    this.disable_submit == true
                      ? 'bg-gray-200 text-black cursor-not-allowed'
                      : 'bg-blues hover:bg-hover cursor-pointer text-white'
                  "
                  class="px-4 py-2 md:py-1 rounded-r-xl"
                >
                  <img
                    src="@/assets/search.webp"
                    alt="Search"
                    class="w-6 h-6"
                  />
                </button>
                <img
                  v-if="disable_submit"
                  src="@/assets/loading.gif"
                  alt="loading"
                  class="w-6 h-6 object-contain"
                />
              </div>
              <!-- <button
                type="submit"
                class="bg-blues py-2 md:py-1 rounded-r-xl text-white px-4"
              >
                <img src="@/assets/search.webp" alt="Search" class="w-6 h-6" />
              </button> -->
            </form>
          </div>

          <div
            v-if="loading"
            class="flex items-center justify-center h-[calc(100vh-350px)]"
          >
            <img src="@/assets/newd/loading.gif" alt="Loading" />
          </div>
          <div v-else>
            <div
              v-if="courselist.length > 0"
              class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-6 sm:gap-8 lg:gap-10"
            >
              <div
                class="rounded-3xl shadow-md"
                v-for="course in courselist"
                :key="course"
              >
                <div
                  class="flex flex-col min-h-[300px] justify-between text-start sm:text-left px-4 sm:px-6 py-6"
                >
                  <img
                    v-if="course.thumbnail"
                    class="object-cover object-center h-[200px] w-full rounded-lg"
                    :src="course.thumbnail"
                    alt="Course Thumbnail"
                  />
                  <img
                    v-else
                    class="object-cover object-center h-24 w-52 mx-auto sm:mx-0 rounded"
                    src="@/assets/coding.svg"
                    alt="Default Thumbnail"
                  />

                  <router-link
                    :to="{
                      name: 'InstructorStudents',
                      params: {
                        course_id: course.id,
                        department_id: course.department.id,
                      },
                    }"
                    class="flex flex-col gap-1"
                  >
                    <h1 class="font-bold text-md text-primary py-2">
                      {{ course.title.slice(0, 50) }}
                      <p
                        v-if="course.title.length > 50"
                        class="text-primary text-sm mt-1 font-semibold"
                      >
                        ...More
                      </p>
                    </h1>
                  </router-link>

                  <div class="flex items-center gap-10 mt-5">
                    <!-- <div @click="editCoursePopup = true; currentId = course.id">
                    <img src="@/assets/newd/icon2.svg" alt="Edit Course" />
                  </div> -->

                    <div
                      @click="
                        addLessonUnitPopup = true;
                        currentId = course.id;
                      "
                    >
                      <img src="@/assets/newd/icon1.svg" alt="Add Course" />
                    </div>

                    <div
                      @click="
                        titlepass = course.title;
                        popupwindow = true;
                        idpass = course.id;
                      "
                      class="cursor-pointer"
                    >
                      <img src="@/assets/newd/icon3.svg" alt="Delete Course" />
                    </div>

                    <router-link
                      :to="{
                        name: 'AdminCoursePreview',
                        params: { course_id: course.id },
                      }"
                      class="cursor-pointer bg-blues text-white px-3 py-1 text-sm font-bold rounded-2xl transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                    >
                      Preview
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="courselist.length > 0"
              class="flex justify-center py-4 space-x-2"
            >
              <button
                class="px-3 py-2 bg-gray-200 rounded disabled:opacity-50"
                :disabled="currentPage === 1"
                @click="prevPage"
              >
                &laquo;
              </button>
              <!-- {{ currentPage%pageSize }} {{ currentPage }} -->
              <button
                v-for="page in visiblePages"
                :key="page"
                class="px-3 py-2 rounded"
                :class="{
                  'bg-blue-500 text-white': currentPage === page,
                  'bg-white border border-gray-400 text-gray-800':
                    currentPage !== page,
                }"
                @click="changePage(page)"
              >
                {{ page }}
              </button>

              <button
                class="px-3 py-2 bg-gray-200 rounded disabled:opacity-50"
                :disabled="currentPage >= totalPages"
                @click="nextPage"
              >
                &raquo;
              </button>
            </div>

            <div v-else class="text-lg font-normal text-center">
              No data Found
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="addLessonUnitPopup"
        class="fixed z-50 w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0"
      >
        <AddLessonUnit
          :course_id="currentId"
          @close-AddUnit="closeReciveEmitAddUnit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Admin/Header.vue";
import SideBar from "@/components/Admin/SideBar.vue";
import ConfirmPopup from "@/components/ConfirmPopup.vue";
import FlashMessage from "@/components/FlashMessage.vue";

import AddLessonUnit from "@/components/Common/AddLessonUnit.vue";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: {
    Header,
    SideBar,
    FlashMessage,
    ConfirmPopup,
    AddLessonUnit,
  },
  data() {
    return {
      courselist: "",
      instructorInfo: "",
      messages: "",
      popupwindow: false,
      loading: true,
      search_title: "",
      currentId: null,
      addLessonUnitPopup: false,
      currentPage: 1,
      totalPages: 1,
      pageSize: 5,
      pageArray: [],
      disable_submit: false,
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),
    visiblePages() {
      const start =
        Math.floor((this.currentPage - 1) / this.pageSize) * this.pageSize;
      const end = Math.min(start + this.pageSize, this.totalPages);
      return this.pageArray.slice(start, end);
    },
  },

  watch: {
    courselist() {
      for (let i = 1; i < this.totalPages + 1; i++) {
        this.pageArray.push(i);
      }
      // this.setPages();
    },
  },

  async created() {
    await axios
      .get(
        `${process.env.VUE_APP_API}/instructor/?Key=${this.userInfo.token_key}`
      )
      .then((response) => {
        this.instructorInfo = response.data;
      });

    this.getCourses(1);
  },
  methods: {
    closeReciveEmitAddUnit() {
      this.addLessonUnitPopup = false;
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getCourses(this.currentPage);
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getCourses(this.currentPage);
      }
    },

    changePage(page) {
      this.currentPage = page;
      this.getCourses(page);
    },

    async getCourses(page) {
      await axios
        .get(
          `${process.env.VUE_APP_API}/courses/?page=${page}&Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          this.totalPages = response.data.data.total_page;
          this.courselist = response.data.data.data.data;
          this.loading = false;

        

          // this.courselist.forEach((element) => {
          //   element.displayprice = new Intl.NumberFormat("hi-IN", {
          //     style: "currency",
          //     currency: "INR",
          //     maximumFractionDigits: 0,
          //   }).format(element.price);
          // });

          // if (response.data.message == "No courses details") {
          //   console.log("Null");
          // } else {

          // if (
          //   response.data &&
          //   response.data.data &&
          //   response.data.data.length > 0
          // ) {

          // }
          // }
        })
        .catch((err) => {
          console.log("error", err);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 600);
        });
    },

    async DuplicateCourse(course_id) {
      await axios
        .get(
          `${process.env.VUE_APP_API}/courseduplicate/${course_id}/?Key=${this.userInfo.token_key}`,
          {}
        )
        .then((response) => {
          if (response.data.status == 200) {
            // this.coursedetailsget();
            this.messages = {
              text: "Course Duplicated",
              type: "success",
            };
            setTimeout(() => {
              axios
                .get(
                  `${process.env.VUE_APP_API}/courses/?instructor=${this.instructorInfo.id}&Key=${this.userInfo.token_key}`
                )
                .then((response) => {
                  if (response.data.message == "No courses details") {
                  } else {
                    this.courselist = response.data.data;

                    this.courselist.forEach((element) => {
                      element.displayprice = new Intl.NumberFormat("hi-IN", {
                        style: "currency",
                        currency: "INR",
                        maximumFractionDigits: 0,
                      }).format(element.price);
                    });
                  }
                });

              this.messages = {
                text: "",
                type: "",
              };
            }, 1000);
          } else {
            console.log("Course Duplicated Failed");
            this.messages = {
              text: " Course Duplicated Failed",
              type: "error",
            };
          }
        });
    },

    async deletecourse(data) {
      await axios
        .delete(
          `${process.env.VUE_APP_API}/courseupdate/${data}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          this.res = response;
          if (this.res.statusText == "No Content") {
            this.messages = {
              text: "Deleted successfully",
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        });
      this.popupwindow = false;
      setTimeout(() => {
        // this.getCourses();
        this.$router.go(0);
        this.messages = {
          text: "",
          type: "null",
        };
      }, 2000);
    },

    async searchUserValue() {
      this.disable_submit = true;
      await axios
        .get(
          `${process.env.VUE_APP_API}/courses/?title=${this.search_title}&Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.message == "No courses details") {
            console.log("Null");
          } else {
            // this.courselist = response.data.data;

            this.totalPages = response.data.data.total_page;
            this.courselist = response.data.data.data.data;
            this.loading = false;

            // this.courselist.forEach((element) => {
            //   element.displayprice = new Intl.NumberFormat("hi-IN", {
            //     style: "currency",
            //     currency: "INR",
            //     maximumFractionDigits: 0,
            //   }).format(element.price);
            // });
          }
        })
        .finally(() => {
          this.disable_submit = false;
        });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
